// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__03HX7","noResize":"Textarea_noResize__l9tak","clear":"Textarea_clear__I55fx"};